module.exports = __webpack_public_path__ + "media/images/common/lp/bg-stepBox-a255d779561cf10fbae40b05ec5b6da7.png";